export enum Role {
  User = 'User',
  ProgramManager = 'ProgramManager',
  Admin = 'Admin',
  LocalAdmin = 'LocalAdmin'
}
